import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {
  getApplicationDataHasFailed,
  getApplicationDataIsLoaded,
  getApplicationDataIsLoading,
} from '../../../redux/modules/applicationData/applicationData.selectors';
import {
  doesEverySystematicHaveAnAgreement,
  doesUserLEGoToTrust,
  getIsRMDFundNonIRA,
  getIsRMDSpecialPayee,
  getOnlyOWNRRMDs,
  getRMDfunds,
  getUserFunds,
  getUsersRetirementFunds,
} from '../../../redux/modules/UserFunds/userFunds.selectors';
import {
  getIsRMDBalanceAndAmountIsZero
} from '../../../redux/modules/RMD/RMDSetting.selectors';
import {parseExistingRMD} from '../../../utils/utils';
import {moduleActions} from '../../../redux/modules';
import {REINVEST_STEP} from '../../../settings/settings';
import {
  isExistingSet
} from '../../../redux/modules/shoppingCart/shoppingCart.selectors';
import {
  getExistingBanks
} from '../../../redux/modules/existingBanks/existingBanks.selectors';
import {
  getWithholdingStateLookup
} from '../../../redux/modules/stateWithholding/stateWithholding.selectors';
import {
  getHouseholdSegmentInformation
} from '../../../redux/modules/PersonalInformation/personalInformation.selectors';
import initServiceCalls from '../../../services';

const LandingRedirect = ({ children, goToStart }) => {
  const dispatch = useDispatch();
  const loaded = useSelector(getApplicationDataIsLoaded);
  const isLoading = useSelector(getApplicationDataIsLoading);
  const hasError = useSelector(getApplicationDataHasFailed);
  const enableDistributionMethod = useSelector(getHouseholdSegmentInformation);
  const userLETrust = useSelector(doesUserLEGoToTrust);
  const userFunds = useSelector((state) => getUsersRetirementFunds(state));
  const RMDBalanceAndAmountIsZero = useSelector(getIsRMDBalanceAndAmountIsZero);
  const allFunds = useSelector((state) => getUserFunds(state));
  const hasExistingRMD = useSelector((state) => getOnlyOWNRRMDs(state));
  const isExistingRMDSet = useSelector((state) => isExistingSet(state));
  const userBanks = useSelector((state) => getExistingBanks(state));
  const statePercentLookUp = useSelector(getWithholdingStateLookup);
  const {
    ROLLOVER_IRA: { lockedFunds: rolloverLockedFunds },
    TRADITIONAL_IRA: { lockedFunds: traditionalLockedFunds },
  } = useSelector(getRMDfunds);
  const isRMDSpecialPayee = useSelector(getIsRMDSpecialPayee);
  const isRMDFundNonIRA = useSelector(getIsRMDFundNonIRA);
  const sytematicsMatch = useSelector(doesEverySystematicHaveAnAgreement);
  const isGetStartedClicked = useSelector(
    (state) => state.shoppingCart.getStartedClicked
  );

  const rmdIsHidden = hasExistingRMD?.some((fund) => fund.hidden);
  const isPending = hasExistingRMD?.some((fund) => fund.pending === true);
  const canNotEdit =
    userLETrust ||
    // RMDBalanceAndAmountIsZero ||
    isRMDSpecialPayee ||
    isRMDFundNonIRA;
  const callToEdit =
    userLETrust ||
    // RMDBalanceAndAmountIsZero ||
    isRMDSpecialPayee ||
    isRMDFundNonIRA ||
    !sytematicsMatch ||
    rmdIsHidden;

  const search = window.location.search;
  const [navPageHasChanged, setNavPageHasChanged] = useState(false);
  const [test, isTest] = useState(false);
  /* eslint-disable */

  useEffect(() => {
    document.documentElement.scrollTop = 0; // for some older browsers
    window.scrollTo(0,0)
    if (!loaded) {
      initServiceCalls(dispatch);
    }
  }, []);

  /* eslint-enable */
  if (
    hasExistingRMD &&
    hasExistingRMD.length > 0 &&
    !isExistingRMDSet &&
    !isLoading &&
    !hasError
  ) {
    const editShoppingCart = parseExistingRMD(
      hasExistingRMD,
      userFunds,
      allFunds,
      userBanks,
      statePercentLookUp,
      rolloverLockedFunds,
      traditionalLockedFunds,
      enableDistributionMethod
    );
    dispatch(moduleActions.updateShoppingCarWithExisting(editShoppingCart));
    if (editShoppingCart.selectedDestination === REINVEST_STEP) {
      if (
        editShoppingCart.selectedDistributionMethod.funds.rolloverFunds &&
        editShoppingCart.selectedDistributionMethod.funds.rolloverFunds.length >
          0
      ) {
        dispatch(
          moduleActions.searchExchangeToExistingRollover(
            editShoppingCart.selectedDistributionMethod.funds.rolloverFunds[0]
          )
        );
      }
      if (
        editShoppingCart.selectedDistributionMethod.funds.traditionalFunds &&
        editShoppingCart.selectedDistributionMethod.funds.traditionalFunds
          .length > 0
      ) {
        dispatch(
          moduleActions.searchExchangeToExistingTraditional(
            editShoppingCart.selectedDistributionMethod.funds
              .traditionalFunds[0]
          )
        );
      }
    }
    if (
      !navPageHasChanged &&
      window.location.pathname.includes('destination')
    ) {
      setNavPageHasChanged(true);
      return (
        <Redirect
          to={{
            pathname: '/usis/rmd-tool/edit/destination',
            search: `${search}`,
          }}
        />
      );
    }
  }
  if (callToEdit || (isPending && !callToEdit)) {
    return (
      <Redirect
        to={{
          pathname: '/usis/rmd-tool',
          search: `${search}`,
        }}
      />
    );
  }

  if (
    hasExistingRMD.length &&
    window.location.pathname.includes('destination') &&
    !window.location.pathname.includes('edit')
  ) {
    return (
      <Redirect
        to={{
          pathname: '/usis/rmd-tool/edit/destination',
          search: `${search}`,
        }}
      />
    );
  }

  if (
    !hasExistingRMD.length &&
    loaded &&
    window.location.pathname.includes('destination') &&
    window.location.pathname.includes('edit')
  ) {
    return (
      <Redirect
        to={{
          pathname: '/usis/rmd-tool',
          search: `${search}`,
        }}
      />
    );
  }
  if (!goToStart) {
    if (
      !hasExistingRMD.length &&
      window.location.pathname.includes('destination') &&
      !isGetStartedClicked &&
      loaded
    ) {
      return (
        <Redirect
          to={{
            pathname: '/usis/rmd-tool/start',
            search: `${search}`,
          }}
        />
      );
    }

    return <>{children}</>;
  } else if (canNotEdit) {
    return (
      <Redirect
        to={{
          pathname: '/usis/rmd-tool',
          search: `${search}`,
        }}
      />
    );
  } else if (!isPending && !callToEdit && loaded) {
    return <>{children}</>;
  } else if (hasExistingRMD.length) {
    return window.location.pathname.includes('destination') ? (
      <>{children}</>
    ) : (
      <Redirect
        to={{
          pathname: '/usis/rmd-tool/edit/destination',
          search: `${search}`,
        }}
      />
    );
  } else if (loaded) {
    return <>{children}</>;
  } else if (!hasExistingRMD.length) {
    return window.location.pathname.includes('destination') ? (
      <>{children}</>
    ) : (
      <Redirect
        to={{
          pathname: '/usis/rmd-tool/destination',
          search: `${search}`,
        }}
      />
    );
  } else {
    return (
      <Redirect
        to={{
          pathname: '/usis/rmd-tool',
          search: `${search}`,
        }}
      />
    );
  }
};

export default LandingRedirect;
